import cn from 'classnames';
import React, { FC, useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';

// REDUX
import { getGeneralAppState } from '@Managers/Redux/AppState/AppState';
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';

// STYLES
import style from '@UILayer/UILayer.scss';

// IMAGES
import { getHttpError } from '@Managers/Redux/HttpState';
import warningIcon from './warning_icon.svg';

export const MessageError: FC<{ onClose: Function }> = ({ onClose }) => {
    const [state, setState] = useReducer((state: { code: string; error: string; category: string }, newState: any) => ({ ...state, ...newState }), {
        code: '',
        error: '',
        category: ''
    });

    useEffect(() => {}, []);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const gameStoreGeneralAppState = useAppSelector(getGeneralAppState);
    const httpError = useAppSelector(getHttpError);

    const buttonAction = (e: React.MouseEvent<any>): void => {
        onClose();
    };

    useEffect(() => {
        if (gameStoreGeneralAppState.error) {
            setState({
                code: gameStoreGeneralAppState.error.code,
                error: gameStoreGeneralAppState.error.error
            });
        }

        if (httpError) {
            const errorKey = httpError.statusCode ? (httpError.statusCode >= 500 ? '5XX' : '4XX') : false;
            setState({
                code: httpError.statusCode,
                error: errorKey ? t(`NETWORK_ERROR_${errorKey}`) : ''
            });
        }
    }, [gameStoreGeneralAppState.error, httpError]);

    return (
        <>
            <div className={cn(style.message_icon, style.message_icon_error)}>
                <img src={warningIcon} alt="" />
            </div>
            <div className={style.message_header}>
                {t('ERROR')} {state.code}
            </div>
            <div className={style.message_desc}>{state.error}</div>
            {!httpError && (
                <div className={style.message_actions}>
                    <button className={`${style.popup_btn} ${style.error_btn}`} onPointerDown={(e) => buttonAction(e)}>
                        {t('LOG_OUT')}
                    </button>
                </div>
            )}
        </>
    );
};
